import { Component, OnInit } from '@angular/core';
import {Apikeys} from '../../../../../_models/apikeys';
import {Subject} from 'rxjs';
import {Router} from '@angular/router';
import {ClientesComercioService} from '../clientes-comercio.service';
import {MatDialog} from '@angular/material/dialog';
import {PageHeaderDataService} from '../../../../../shared/services/page-header-data.service';
import {FormBuilder} from '@angular/forms';
import {PageHeaderData} from '../../../../../shared/components/forms-header/page-header-data';
import {takeUntil} from 'rxjs/operators';
import {ClientesComercio} from '../../../../../_models/clientes-comercio';
import {PageEvent} from "@angular/material/paginator";

@Component({
  selector: 'app-list-cliente-comercio',
  templateUrl: './list-cliente-comercio.component.html',
  styleUrls: ['./list-cliente-comercio.component.scss']
})
export class ListClienteComercioComponent implements OnInit {
  displayedColumns = ['nroDocumento', 'nombre', 'apellido', 'telefono', 'id_cliente_entidad', 'fechaHora', 'sincronizacionEstado', 'comercio'];
  dataSource: Array<ClientesComercio> = [];
  estadoList: any[] = [];
  comercioList: any[] = [];
  filter: any = {
    nombre: '',
    apellido: '',
    nroDocumento: '',
    comercio: '',
    sincronizacionEstadoId: '',
    codigoCliente: '',
    entidad: false,
    cantidadPagina: 10,
    pagina: 1
  };
  panelOpenState = true; // muestra/oculta el filtro
  paginacion: any = {
    cantidad: 0,
    por_pagina: 10,
    pagina: 1,
    total: 0,
  };
  filterTimer: any;
  formFilter = null;
  unsubscribe$: Subject<any> = new Subject();

  constructor(
    public router: Router,
    public service: ClientesComercioService,
    public dialog: MatDialog,
    private headerDataService: PageHeaderDataService,
    private fb: FormBuilder,
  ) {
    this.buildForm();
  }

  ngOnInit(): void {
    if (this.router.url === '/procesadora/clientes') {
      this.filter.entidad = false; // no filtrar por entidad
      this.headerDataService.setHeaderData(new PageHeaderData('Lista de Clientes', 'procesadora/clientes', false, false));
    }
    if (this.router.url === '/entidad/clientes') {
      console.log('entidad')
      this.filter.entidad = true; // filtrar por entidad
      this.headerDataService.setHeaderData(new PageHeaderData('Lista de Clientes', 'entidad/clientes', false, false));
    }
    this.getEstadoSincronizacion();
    this.getListaClienteComercio();
  }

  private buildForm() {
    this.formFilter = this.fb.group({
      nroDocumento: [''],
      comercio: [''],
      nombre: [''],
      apellido: [''],
      codigoCliente: [''],
      sincronizacionEstadoId: [''],
    });
    // se enlazan filtros con formulario reactivo
    this.formFilter.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe( data => {
      clearTimeout(this.filterTimer);
      this.filterTimer = setTimeout(() => {
        this.filter.nroDocumento = data.nroDocumento;
        this.filter.nombre = data.nombre;
        this.filter.apellido = data.apellido;
        this.filter.codigoCliente = data.codigoCliente;
        this.filter.comercio = data.comercio;
        this.filter.sincronizacionEstadoId = data.sincronizacionEstadoId === 'TODOS' ? '' : data.sincronizacionEstadoId;
        this.getListaClienteComercio();
        clearTimeout(this.filterTimer);
      }, 500);
    });
  }

  getEstadoSincronizacion() {
    this.service.getSincronizacionEstado().pipe(takeUntil(this.unsubscribe$)).subscribe( resp => {
      this.estadoList = [...[{id: '', nombre: 'TODOS'}], ...resp.data];
    });
  }

  private getListaClienteComercio() {
    this.service.obtenerListaCliente(this.filter)
      .subscribe(
        data => {
          if (data != null && data['data'] != undefined) {
            this.dataSource = data['data'] as any[];
            if (data['pagination']) {
              console.log(data['pagination']['actual'])
              this.paginacion.actual = +data['pagination']['actual'];
              this.paginacion.cantidad = +data['pagination']['cantidad'];
              this.paginacion.por_pagina = +data['pagination']['por_pagina'];
              this.paginacion.total = +data['pagination']['total'];
            }
          } else {
            this.dataSource = [];
            this.paginacion = {
              actual: 1,
              cantidad: 1,
              por_pagina: 10,
              total: 1
            };
          }
          //this.snackbar.noMessage();
        });
  }

  public obtenerDatos(event?: PageEvent) {
    let pagina = 1;
    pagina = event.pageIndex + 1;
    if (event.pageIndex === 0 && event.previousPageIndex === 1) {
      pagina = 1;
    }
    this.filter.cantidadPagina = event.pageSize;
    this.filter.pagina = pagina;
    this.getListaClienteComercio();
    return event;
  }
}
